import React, { useEffect, useState, CSSProperties } from 'react';

interface TimerProps {
  start: boolean;
  stop: boolean;
  date?: Date | string;
  style?: CSSProperties;
  className?: string; 
}

const TimerFunction: React.FC<TimerProps> = ({
  start,
  stop,
  date = new Date(),
  style = {},
  className = '',
}) => {
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [currentTime, setCurrentTime] = useState<Date | null>(null);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (isRunning) {
      interval = setInterval(() => {
        setCurrentTime(new Date());
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isRunning]);

  const handleStart = (startDate: Date | string) => {
    const parsedDate = new Date(startDate);
    setStartTime(parsedDate);
    setCurrentTime(new Date());
    setIsRunning(true);
  };

  const handleStop = () => {
    setIsRunning(false);
    setStartTime(null);
    setCurrentTime(null);
  };

  useEffect(() => {
    if (start) {
      handleStart(date);
    }
  }, [start, date]);

  useEffect(() => {
    if (stop) {
      handleStop();
    }
  }, [stop]);

  const getElapsedTime = (): string => {
    if (!startTime || !currentTime) return '00:00:00';
    const elapsedMilliseconds = currentTime.getTime() - startTime.getTime();
    const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className={className} style={style}>
      <span>{getElapsedTime()}</span>
    </div>
  );
};

export default TimerFunction;
